import React, { useState } from 'react';

const GuardianForm = () => {

  return (
      <div className='flex justify-center'>
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSf4rkJENgU2zvsLad6RKScZCQMgaP2DeqDgCm78qy86pvQddw/viewform?embedded=true" width="640" height="5427" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </div>
  );
};

export default GuardianForm;
